import { PositionType, isPositionVertical, getPositionBase, getOppositePosition } from '../../../library/index';
export function placementToPosition(placement) {
  if (!placement) return null;
  var base = placement.split('-')[0];
  if (base == 'auto') return null;
  return base;
}
export function getBasePosition(position) {
  var base = position.split('-')[0];
  if (base == 'auto') return PositionType.TOP;
  return getPositionBase(position);
}
export function getAlignment(placement) {
  var align = placement.split('-')[1];
  switch (align) {
    case 'start':
      return 'left';
    case 'end':
      return 'right';
    default:
      return 'center';
  }
}
export function positionToPlacement(position) {
  switch (position) {
    case PositionType.TOP_LEFT:
      return 'top-start';
    case PositionType.TOP:
      return 'top';
    case PositionType.TOP_RIGHT:
      return 'top-end';
    case PositionType.RIGHT_TOP:
      return 'right-start';
    case PositionType.RIGHT:
      return 'right';
    case PositionType.RIGHT_BOTTOM:
      return 'right-end';
    case PositionType.BOTTOM_RIGHT:
      return 'bottom-end';
    case PositionType.BOTTOM:
      return 'bottom';
    case PositionType.BOTTOM_LEFT:
      return 'bottom-start';
    case PositionType.LEFT_BOTTOM:
      return 'left-end';
    case PositionType.LEFT:
      return 'left';
    case PositionType.LEFT_TOP:
      return 'left-start';
    case 'auto':
    case 'auto-start':
    case 'auto-end':
      return position;
    default:
      return assertNever(position);
  }
}
function assertNever(x) {
  throw new Error('Unexpected position: ' + x);
}
export function getTransformOrigin(placement) {
  var _placementToPosition;
  var position = (_placementToPosition = placementToPosition(placement)) !== null && _placementToPosition !== void 0 ? _placementToPosition : PositionType.TOP;
  var a = isPositionVertical(position) ? "".concat(getOppositePosition(position), " ").concat(getAlignment(position)) : "".concat(getAlignment(position), " ").concat(getOppositePosition(position));
  return a;
}